import * as React from "react";
import KU55HandlingSelection from "../../components/Forms/KU55/Selection";

export default function KU55Handling() {
  return <KU55HandlingSelection />;
}
